import axios from "../../../context/axiosConfig";

const pozyczkiGetData = async (id) => {
	return axios.post("/pozyczki/get/data", {
		id,
	});
};

export default pozyczkiGetData;
